import {IComponentOptions, ILogService} from "angular";
import {IModalService} from "angular-ui-bootstrap";
import {StateService} from "@uirouter/angularjs";
import {Application} from "../../../shared/model/Application";
import {isSystemAccepted as checkSystemAccepted, isSystemRejected as checkSystemRejected} from "../../../shared/model/ApplicationStatusUtil";
import "./application-table.less";
import {IDescriptionFilter} from "../../../shared/reference-data/description.filter";
import {LoadingService} from "../../../shared/loading/loading.service";
import {ApplicationService} from "../../../shared/application/application.service";

class ApplicationsTableController {

    public onSelect: any;
    public admin: boolean;
    public applications: Application[];
    public sortBy: string;
    public sortByOrder: string;
    public sortReverse: boolean;
    public defaultSortBy: string;
    public defaultSortByOrder: string;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $state: StateService,
                private $uibModal: IModalService,
                private descriptionFilter: IDescriptionFilter,
                private loadingService: LoadingService,
                private applicationService: ApplicationService,
                private moment: any) {
    }

    public $onInit() {
        this.$log.debug("ApplicationsTableController.$onInit: %o", this.admin);
        this.defaultSortBy = "updated";
        this.defaultSortByOrder = "-updated";

        this.setDefaultSortOrder();

        if (this.applications) {
            this.applications.forEach((application) => {
                application.descriptiveStatus = this.descriptionFilter(application.status, "StudentCreditApplicationStatus");
                application.submittedDate = application.submittedDate || application.created || application.updated;
            });
        }
    }

    public select(application: Application) {
        this.$log.debug("select", application.id);

        this.onSelect({
            $event: {
                applicationId: application.id,
                application: application
            }
        });
    }

    public releaseToFacultyAdmin(application: Application) {
        this.$log.debug("release to faculty admin", application.id);
        this.$uibModal.open({
            component: "releaseApplicationModal",
            resolve: {
                application: () => application
            }
        }).result.then((releasedApplication) => {
            this.$log.debug("released to faculty admin: ", releasedApplication.id);
        }, (reason) => {
            this.$log.debug("release to faculty admin modal dismissed: " + reason);
        });
    }

    public showReleaseToFacultyButton(application: Application) {
        const showButton = application.status === "SUBMITTED_WITH_ADMISSIONS";
        return showButton;
    }

    public archiveApplication(application) {
        this.$log.debug("archiveApplication:", application);
        this.$uibModal.open({
            component: "archiveApplicationModal",
            resolve: {
                application: () => application
            }
        }).result.then((archivedApplication) => {
            application = archivedApplication;
        }, (reason) => {
            this.$log.info("modal dismissed: " + reason);
        });
    }

    public processOffline(application) {
        if (application.status !== "APPROVED" && !application.archived && !checkSystemRejected(application.status) && !checkSystemAccepted(application.status)) {
            this.$log.debug("processOffline:", application);
            this.$uibModal.open({
                component: "offlineModal",
                resolve: {
                    application: () => application
                }
            }).result.then((returningApplication) => {
                application = returningApplication;
            }, (reason) => {
                this.$log.info("modal dismissed: " + reason);
            });
        }
    }

    public unarchiveApplication(application) {
        this.$log.debug("unarchiveApplication:", application);
        this.loadingService.show();

        this.applicationService.unarchiveStudentCreditApplication(application)
            .then((unarchivedApp) => {
                this.$log.debug("unarchivedApplication:", unarchivedApp);
                this.$state.go("staff.dashboard", {}, {reload: true});
            })
            .finally(() => {
                    this.loadingService.hide();
                }
            );
    }

    public getApplicationPastDeadlineClassName(application: Application) {
        if (application.status !== "APPROVED" &&
            application.status !== "DECLINED" &&
            this.isApplicationPastDeadline(application.submittedDate)) {
            return "text-danger";
        }

        return "";
    }

    public getApplicationIsSystemRejected(application: Application) {
        if (checkSystemRejected(application.status)) {
            return "text-danger";
        } else {
            return "";
        }
    }

    /**
     * Check if the application status indicates system acceptance.
     */
    public isSystemAccepted(status: string): boolean {
        return checkSystemAccepted(status);
    }

    /**
     * Check if the application status indicates system rejection.
     */
    public isSystemRejected(status: string): boolean {
        return checkSystemRejected(status);
    }

    public hasPreferredName(application: Application){
        if (application.applicant.preferredName){
            return application.applicant.preferredName.trim().length > 0;
        }
        return false;
    }

    public setSortBy(sortBy: string) {
        if (this.sortBy === "descriptiveStatus" && this.sortBy === sortBy) {
            // User selected to sort by status second time. Switch to default sort order
            this.setDefaultSortOrder();
        } else if (this.sortBy === "submittedDate" && this.sortBy === sortBy) {
            if (!this.sortReverse) {
                // User selected sort by 'submittedDate' for second time - reverse the sort order
                this.sortReverse = true;
            } else {
                // User selected sort by 'submittedDate' for third time - reset to default sort
                this.setDefaultSortOrder();
            }

        } else {
            this.sortBy = sortBy;
            this.sortReverse = false;
        }

        this.sortByOrder = (!this.sortReverse ? "" : "-") + this.sortBy;
    }

    private isApplicationPastDeadline(submittedDate) {
        return this.moment(this.moment.now()).diff(this.moment(submittedDate), "days") > 14;
    }

    private setDefaultSortOrder() {
        this.sortBy = this.defaultSortBy;
        this.sortByOrder = this.defaultSortByOrder;
        this.sortReverse = true;
    }
}

export const ApplicationsTableComponent: IComponentOptions = {
    bindings: {
        applications: "<",
        onSelect: "&",
        admin: "<?"
    },
    controller: ApplicationsTableController,
    template: require("./applications-table.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/application/table/applications-table.component.ts